const ClipboardPort = {
  add: (app) => {
    app.ports.copyToClipboard.subscribe((text) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch((err) => {
          console.error("Clipboard write failed:", err);
        });
      }
    });
  },
};

module.exports = ClipboardPort;
